// Import components
import InvoiceModalContent from '../../components/Invoices/InvoiceModalContent';
import InvoiceNewInitializer from '../../components/Invoices/InvoiceNewInitializer';
import Invoices from '../../components/Invoices/Invoices';
import invoicesListAndModal from './invoicesModal';
import CreateProductModal from '../../components/ProductsAndServices/SelectedProducts/CreateProductModal';
import CustomersNewModal from '../../components/Customers/CustomersNewModal';
import AddProduct from '../../components/ProductsAndServices/SelectedProducts/AddProduct';
// import getHeaderTooltip from '../../components/HelpTooltip/getHeaderTooltip';

// Loaders and actions
import {
  createInvoiceAction,
  updateInvoiceAction,
  invoiceLoader,
  invoicesLoader,
  nextInvoiceNumberLoader,
  createProductModalAction,
} from './invoicesLA';
import { createCustomerAction } from '../customers/customersLA';

// Extra routes
import projectManagersRoutes from './projectManagers';

export const customerModalRoute = () => ({
  path: 'new-customer',
  element: <CustomersNewModal />,
  action: ({ request, params }) =>
    createCustomerAction({ request, params, hardRedirect: '..' }),
});

export const productModalRoutes = () => [
  { path: 'add-product', element: <AddProduct /> },
  {
    path: 'create-product',
    action: createProductModalAction,
    element: <CreateProductModal />,
  },
];

const createInvoice = (routeId) => {
  return [
    {
      path: '',
      element: <Invoices />,
      loader: invoicesLoader,
      handle: {
        linkTo: {
          label: 'New',
          to: 'new',
          // toolTip: (matches) => getHeaderTooltip(matches, 'invoice'),
        },
      },
      children: [
        ...projectManagersRoutes,
        {
          path: ':invoiceId',
          loader: invoiceLoader,
          id: routeId,
          handle: {
            crumb: (match) =>
              `${
                match?.data?.data?.invoice?.number || 'Invoice number missing'
              }`,
          },
          children: [
            {
              path: '',
              element: <InvoiceModalContent />,
              children: [...invoicesListAndModal],
            },
          ],
          errorElement: <p>Sorry, an unexpected error has occurred.</p>,
        },
      ],
    },
    { path: 'nextInvoiceNumber', loader: nextInvoiceNumberLoader },
    {
      path: 'new',
      element: <InvoiceNewInitializer />,
      action: createInvoiceAction,
      handle: {
        crumb: () => 'New',
        linkTo: {
          noShow: true,
        },
      },
      children: [customerModalRoute(), ...productModalRoutes()],
    },

    {
      path: ':invoiceId',
      loader: invoiceLoader,
      handle: {
        crumb: (match) =>
          `${match?.data?.data?.invoice?.number || 'Invoice number missing'}`,
      },
      children: [
        {
          path: 'edit',
          element: <InvoiceNewInitializer />,
          action: updateInvoiceAction,
          loader: invoiceLoader,
          handle: {
            crumb: (response) =>
              `Edit ${response?.data?.data?.invoice?.number || 'invoice'}`,
            linkTo: {
              noShow: true,
            },
          },
          children: [customerModalRoute(), ...productModalRoutes()],
        },

        {
          path: 'copy',
          element: <InvoiceNewInitializer copy />,
          action: ({ request, params }) =>
            createInvoiceAction({ request, params, copy: true }),
          loader: invoiceLoader,
          handle: {
            crumb: (match) =>
              `Copy ${match?.data?.data?.invoice?.number || 'Invoice'}`,
            linkTo: {
              noShow: true,
            },
          },
          children: [customerModalRoute(), ...productModalRoutes()],
        },
      ],
    },
  ];
};

export default createInvoice;
